module.exports = __webpack_public_path__ + "static/img/0009-A-01.3ca778a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0009-A-01.jpg
// module id = f+hq
// module chunks = 0